import { Link } from "react-router-dom";

interface HeroSectionProps {
  title: string;
  subtitle: string;
  description: string;
  cta: string;
  ctaSecondary: string;
}

export default function HeroSection({ title, subtitle, description, cta, ctaSecondary }: HeroSectionProps) {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20cream%20and%20warm%20amber%20gradients%20flowing%20organic%20shapes%20gentle%20curves%20minimalist%20elegant%20composition%20with%20subtle%20texture%20and%20light%20golden%20undertones%20warm%20inviting%20atmosphere%20perfect%20for%20a%20premium%20lifestyle%20brand%20hero%20section&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="爱威奶 - 品质新选择"
          title="爱威奶官网首页背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 tracking-wide">
          {title}
        </h1>
        <p className="text-lg md:text-2xl text-white/90 font-light mb-3 md:mb-4">
          {subtitle}
        </p>
        <p className="text-sm md:text-base text-white/75 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm md:text-base whitespace-nowrap transition-all duration-200 cursor-pointer"
          >
            {cta}
          </Link>
          <a
            href="#reviews"
            className="px-8 py-3 bg-white/20 hover:bg-white/30 text-white font-medium rounded-full text-sm md:text-base whitespace-nowrap backdrop-blur-sm transition-all duration-200 cursor-pointer"
          >
            {ctaSecondary}
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#advantages" className="text-white/60 hover:text-white transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}